import request from '@/utils/request'

/**
 * 时间图谱
 * @param {*} data
 * @returns
 */
export function timeGraphOutput (data) {
  return request({
    url: '/zstp/neo4j/time_graph_output/',
    method: 'post',
    responseType: 'blob',
    data
  })
}

/**
 * 高级搜索
 * @param {*} data
 * @returns
 */
export function advancedSearchOutput (data) {
  return request({
    url: '/zstp/neo4j/advanced_search_output//',
    method: 'post',
    responseType: 'blob',
    data
  })
}
